// extracted by mini-css-extract-plugin
module.exports = {"heading":"NoResults_heading__pOk29","didYouMean":"NoResults_didYouMean__lTt99","searchTips":"NoResults_searchTips__kzJp7"};